module.exports = __webpack_public_path__ + "img/2.a8b73ec2.png";